import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import CircularProgress from '@material-ui/core/CircularProgress';
import { deleteCards, editFigures, filterChange, setLoadedLevels, toggleSwitch } from '../../actions/index';
import { getFiguresData } from '../../functions/getData';
import { getFiguregroupsMap } from '../../functions/getter';
import { FilterActions, ToggleActions } from '../../constants/constants';

class RefreshButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            disableButton: false
        };
    }

    handleOnClick = async () => {
        this.setState({ disableButton: true });
        try {
            this.props.toggleSwitch(ToggleActions.REFRESH, true);
            await this.reloadFigures();
            this.removeCardsGroups();
            this.removeLoadedLevels();
            this.reloadLevels();
        } catch (error) {
            console.log('Error al recargar registros');
        }
        this.props.toggleSwitch(ToggleActions.REFRESH, false);
        this.setState({ disableButton: false });
    }

    async reloadFigures() {
        let figuresData = await getFiguresData(this.props.projectData.id);
        let figuregroupsMap = getFiguregroupsMap(figuresData);
        this.props.editFigures(figuresData, figuregroupsMap);
    }

    removeCardsGroups() {
        let cardsGroupIds = [];
        for (const cardsGroupData of Object.values(this.props.projectData.cards_groups)) {
            if (this.props.levelIds.includes(cardsGroupData.attributes.level_id)) {
                cardsGroupIds.push(cardsGroupData.id);
            }
        }
        this.props.deleteCards(cardsGroupIds);
    }

    removeLoadedLevels() {
        let notReloadlevelIds = [];
        for (const levelId of this.props.loadedLevels) {
            if (!this.props.levelIds.includes(levelId)) {
                notReloadlevelIds.push(levelId);
            }
        }
        this.props.setLoadedLevels(notReloadlevelIds);
    }

    reloadLevels() {
        let levelIdsToReload = [...this.props.levelIds];
        this.props.filterChange(FilterActions.LEVELS, []);
        this.props.filterChange(FilterActions.LEVELS, levelIdsToReload);
    }

    render() {       
        return(
            <Button 
                variant='contained' 
                className='refresh-button' 
                onClick={this.handleOnClick}
                disabled={this.props.loadingLevel || this.state.disableButton}
            >   
                { this.state.disableButton ?
                 <CircularProgress size='1.5rem'/>
                 :
                 <RefreshIcon fontSize='large'/>
                }
            </Button>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        projectData  : state.projectData,
        levelIds     : state.filters.levelIds,
        loadingLevel : state.switches.loadingLevel,
        loadedLevels : state.loadedLevels,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        deleteCards     : deleteCards,
        setLoadedLevels : setLoadedLevels,
        filterChange    : filterChange,
        editFigures     : editFigures,
        toggleSwitch    : toggleSwitch
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(RefreshButton);